import { defineComponent as _defineComponent } from 'vue'
import EditIcon from '@/components/molecules/EditIcon.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AddIcon',
  props: {
  canAdd: Boolean
},
  setup(__props) {



return { __sfc: true,EditIcon }
}

})